import mixpanel from 'mixpanel-browser'

const debug = import.meta.env.VITE_TRACKER_DEUG === 'true'
const verbose = import.meta.env.VITE_TRACKER_VERBOSE === 'true' || import.meta.env.DEV

const config = {
  token: import.meta.env.VITE_MIXPANEL_TOKEN,
  config: {
    debug: import.meta.env.VITE_MIXPANEL_CONFIG_DEBUG === 'true',
    test: import.meta.env.VITE_MIXPANEL_CONFIG_TEST === 'true',
    verbose: import.meta.env.VITE_MIXPANEL_CONFIG_VERBOSE === 'true'
  }
}

if (debug) console.info('[tracker]', 'config', config)

class Tracker {
  constructor () {
    if (verbose) console.info('[tracker]', 'initializing...')
    try {
      if (!config.token || config.token.trim() === '') {
        throw new Error('No token provided for mixpanel tracking')
      }
      mixpanel.init(config.token, config.config)
      this.mixpanel = mixpanel
      this.id = null
      this.properties = {}
      if (verbose) console.info('[tracker]', 'initialized.')
    } catch (error) {
      if (verbose) console.info('[tracker]', 'mixpanel initialization failed', error.message)
    }
  }

  track (eventName, properties, options = {}) {
    if (debug) console.debug('[tracker]', 'track', eventName, properties, options)
    if (!this.mixpanel) return
    return this.mixpanel.track(eventName, properties, options)
  }

  identify (id) {
    if (!this.mixpanel) return
    if (this.id === id) return
    if (this.id && this.id !== id) this.reset()
    this.id = id
    if (debug) console.debug('[tracker]', 'identify id', id)
    return this.mixpanel.identify(id)
  }

  setPeopleData (prop, to = null, callback = null) {
    if (!this.mixpanel) return
    if (!to && typeof prop === 'object') {
      const newProp = Object.fromEntries(Object.entries(prop).filter(([key, value]) => !this.properties[key] || this.properties[key] !== value))
      if (Object.keys(newProp).length === 0) {
        if (debug && verbose) console.debug('[tracker]', 'setPeopleData', 'no new properties')
        return
      }
      this.properties = { ...this.properties, ...newProp }
      if (debug) console.debug('[tracker]', 'setPeopleData', newProp)
      return this.mixpanel.people.set(newProp, null, callback)
    }
  }

  appendPeopleData (prop, to = null, callback = null) {
    if (!this.mixpanel) return
    if (!to && typeof prop === 'object') {
      const newProp = Object.fromEntries(Object.entries(prop).filter(([key, value]) => !this.properties[key] || this.properties[key] !== value))
      if (Object.keys(newProp).length === 0) {
        if (debug && verbose) console.debug('[tracker]', 'appendPeopleData', 'no new properties')
        return
      }
      this.properties = { ...this.properties, ...newProp }
      if (debug) console.debug('[tracker]', 'appendPeopleData', newProp)
      return this.mixpanel.people.append(newProp, null, callback)
    }
  }

  reset () {
    if (debug) console.debug('[tracker]', 'reset')
    this.id = null
    this.properties = {}
    if (!this.mixpanel) return
    return this.mixpanel.reset()
  }
}

export const tracker = new Tracker()
